import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class DisplayValue extends BaseOption {
  static userInterfaceComponent = {
    label: "Display Value",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Show",
          value: "show",
        },
        {
          label: "Hide",
          value: "hide",
        },
      ],
    },
  };

  static defaultValue = "show";
}
